import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.7071 15.5429C12.3166 15.9334 11.6834 15.9334 11.2929 15.5429L6.20711 10.4571C5.57714 9.82714 6.02331 8.75 6.91421 8.75H17.0858C17.9767 8.75 18.4229 9.82714 17.7929 10.4571L12.7071 15.5429Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDropdown);
export default ForwardRef;
